import { gSupportEmail, gUseGenericSupportContact } from "../whitelabel/brand";
import { appstr } from "./appstr";

export function GetSupportContact() {
  return gUseGenericSupportContact ? appstr("supportContactGeneric") : gSupportEmail;
}
